import { useEffect, useState } from "react";
import { v4 } from "uuid";
//---------------------------------------------------------------------
import Modal from "src/components/common/modal";
import { ReactComponent as Upload } from "src/img/svg/upload.svg";
import { useMyStore } from "src/components/main/mainStore";
import {
    MyFormData,
    myAxios
} from "src/components/common/functions";
//---------------------------------------------------------------------
export default function Settings({
    closeIt, 
    tabTitle, 
    history
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const pathname = history.location.pathname + (history.location.hash ?? "");
    const id = pathname.split("/")[3];
    const action = pathname.split("/")[4];
    const [data, setData] = useState({});
    useEffect(() => {
        let isMounted = true;
        const getData = async() => {
            //---------------------------------------------------------------------
            setShowLoader(true);
            const res = await myAxios("fleet/readInventory.php");
            if(!isMounted) return;
            setShowLoader(false);
            if(!res) return;
            //---------------------------------------------------------------------
            setData(res.data);
        }
        getData();
        return () => isMounted = false;
    }, [])
    return (
        <Modal
            closeIt = {closeIt}
            title = {"Settings"}
            width = {"60%"}
            actionKey = "Save"
            handleFormSubmit = {async() => {
                if(Object.values(data).map(({title}) => title).some((item, index, self) => self.indexOf(item) !== index)){
                    window.alert("Some titles are duplicated.");
                    return;
                }
                const formData = new MyFormData();
                formData.append("data", JSON.stringify(data));
                //---------------------------------------------------------------------
                setShowLoader(true);
                const res = await myAxios("fleet/updateInventory.php", formData);
                setShowLoader(false);
                if(!res) return;
                //---------------------------------------------------------------------
                closeIt();
            }}
        >
            {Object.entries(data).map(([hashKey, value], index) => 
            <li className = "my-3 d-flex align-items-center" key = {index}>
                <label className = "mr-2" htmlFor = {hashKey + " title"}>Item {index + 1}</label>
                {value.path?
                <img
                    className = "mr-2 rounded"
                    src = {value.path ?? ""}
                    style = {{width: 100, height: 100}}
                    alt = ""
                />:<></>}
                <input
                    required
                    id = {hashKey + " title"}
                    className = {`form-control flex-grow-1${Object.values(data).filter(({title}) => title === value.title).length > 1?" text-danger":""}`}
                    value = {value.title ?? ""}
                    onChange = {e => {
                        const value = e.currentTarget.value;
                        setData({
                            ...data, 
                            [hashKey]: {
                                ...data[hashKey],
                                title: value
                            }
                        });
                    }}
                />
                <label className = "ml-2" htmlFor = {hashKey + " note"}>Note</label>
                <input
                    id = {hashKey + " note"}
                    className = {`ml-2 form-control flex-grow-1`}
                    value = {value.note ?? ""}
                    onChange = {e => {
                        const value = e.currentTarget.value;
                        setData({
                            ...data, 
                            [hashKey]: {
                                ...data[hashKey],
                                note: value
                            }
                        });
                    }}
                />
                <span>
                <button
                    className = "btn btn-danger ml-2"
                    type = "button"
                    onClick = {async() => {
                        if(value.path){
                            if(!window.confirm("Are you sure to delete this item?\n(this action will delete the image from server.)")) return;
                            const formData = new MyFormData();
                            formData.append("hashKey", hashKey);
                            formData.append("path", value.path.split("?")[0].split("/").pop() ?? "");
                            //---------------------------------------------------------------------
                            setShowLoader(true);
                            const res = await myAxios("fleet/deleteInventoryItemImage.php", formData);
                            setShowLoader(false);
                            if(!res) return;
                            //---------------------------------------------------------------------
                        }
                        const newData = {...data};
                        delete newData[hashKey];
                        setData(newData);
                    }}
                >
                    Delete
                </button>
                </span>
                <span>
                    <button
                        className = "btn btn-primary ml-2"
                        type = "button"
                        onClick = {e => e.currentTarget.nextElementSibling.click()}
                    >
                        <Upload/>
                    </button>
                    <input
                        id = {hashKey + " upload"}
                        type = "file"
                        accept = "image/png, image/jpeg"
                        className = "nodisplay"
                        onChange = {async e => {
                            const target = e.currentTarget;
                            if(target.files.length === 0) return;
                            const formData = new MyFormData();
                            formData.append("hashKey", hashKey);
                            formData.append("path", value.path?.split("?")[0].split("/").pop() ?? "");
                            formData.append("profile", target.files[0]);
                            // target.value = "";
                            //---------------------------------------------------------------------
                            setShowLoader(true);
                            const res = await myAxios("fleet/updateInventoryItemImage.php", formData);
                            setShowLoader(false);
                            if(!res) return;
                            //---------------------------------------------------------------------
                            setData({
                                ...data, 
                                [hashKey]: {
                                    ...data[hashKey],
                                    path: res.data + "?" + Date.now()
                                }
                            });
                            target.value = "";
                        }}
                    />
                </span>
                <span>
                    {value.path?
                    <button
                        className = "btn btn-danger ml-2"
                        type = "button"
                        onClick = {async () => {
                            if(!window.confirm("Are you sure to delete this item?\n(this action will delete the image from server.)")) return;
                            const formData = new MyFormData();
                            formData.append("hashKey", hashKey);
                            formData.append("path", value.path.split("?")[0].split("/").pop() ?? "");
                            //---------------------------------------------------------------------
                            setShowLoader(true);
                            const res = await myAxios("fleet/deleteInventoryItemImage.php", formData);
                            setShowLoader(false);
                            if(!res) return;
                            //---------------------------------------------------------------------
                            setData({
                                ...data, 
                                [hashKey]: {
                                    ...data[hashKey],
                                    path: ""
                                }
                            });
                        }}
                    >
                        X
                    </button>
                    :<></>}
                </span>
                <span>
                    <button type = "button" className = "btn btn-info ml-2" onClick = {() => {
                        history.push(`/${tabTitle}/Settings/${hashKey}/order`);
                    }}>
                        ⇅
                    </button>
                    {action === "order"?
                    <Order
                        id = {id}
                        closeIt = {() => history.push(`/${tabTitle}/Settings`)}
                        setData = {setData}
                        data = {data}
                    />:<></>}
                </span>
            </li>)
            }
            <button
                type = "button"
                className = "btn btn-info my-2"
                onClick = {() => {
                    let rand = v4().slice(0, 8);
                    while(rand in data){
                        rand = v4().slice(0, 8);
                    }
                    setData({
                        ...data, 
                        [rand]: {
                            title: "",
                            note: "",
                            path: ""
                        }
                    });
                }}
            >
                Add
            </button>
        </Modal>
    )
}

function Order({ id, data, setData, closeIt }){
    const arr = Object.entries(data).map((entry, index) =>([...entry, index]));
    const originIndex = arr.find(entry => entry[0] === id)[2];
    const [target, setTarget] = useState("");
    return(
        <Modal
            touchOutsideClose
            closeIt = {closeIt}
            title = {"Change Order of " + data[id].title}
            width = {"60%"}
            onSave = {() => {
                const result = [];
                if(!target){
                    result.push([id, data[id]], ...arr.filter(entry => entry[0] !== id));
                }else{
                    let targetIndex = -1;
                    for(let i = 0; i < arr.length; i++){
                        if(arr[i][0] === target){
                            targetIndex = i;
                        }
                    }
                    result.push(
                        ...arr.slice(0, targetIndex + 1).filter(entry => entry[0] !== id), 
                        [id, data[id]],
                        ...arr.slice(targetIndex + 1).filter(entry => entry[0] !== id)
                    )
                }
                setData(Object.fromEntries(result));
                closeIt();
            }}
        >
            <div>
                <select
                    className = "form-control m-3"
                    value = {target}
                    onChange = {e => setTarget(e.currentTarget.value)}
                >
                    <option value = {""} disabled = {originIndex === 0}>
                        At the Top
                    </option>
                    {arr.map(([key, value], renderedIndex) => 
                    <option
                        disabled = {renderedIndex === originIndex || renderedIndex + 1 === originIndex}
                        key = {key}
                        value = {key}
                    >
                        After {value.title}
                    </option>
                    )}
                </select>
            </div>
        </Modal>
    );
}